/**
 * 解析拉伸特征语义类型。
 *
 * @param input 拉伸特征类型和操作语义输入。
 * @returns 归一化后的拉伸特征类型。
 * @throws 当 `featureKind` 与 `operation` 表示的凸台或切除语义不一致时。
 */
export const resolveExtrudeFeatureKind = (input: {
  featureKind?: ExtrudeFeatureKind;
  operation?: ExtrudeOperation;
}): ExtrudeFeatureKind => {
  const { featureKind, operation } = input;

  if (featureKind === 'boss-extrude') {
    if (operation && operation !== 'boss') {
      throw new Error('featureKind=boss-extrude 与 operation=cut 不一致');
    }
    return 'boss-extrude';
  }

  if (featureKind === 'cut-extrude') {
    if (operation && operation !== 'cut') {
      throw new Error('featureKind=cut-extrude 与 operation=boss 不一致');
    }
    return 'cut-extrude';
  }

  if (operation === 'cut') {
    return 'cut-extrude';
  }

  return 'boss-extrude';
};

/**
 * 从拉伸特征类型解析操作语义。
 *
 * @param kind 拉伸特征类型。
 * @returns 操作语义。
 */
export const resolveExtrudeOperationFromKind = (kind: ExtrudeFeatureKind): ExtrudeOperation => {
  return kind === 'cut-extrude' ? 'cut' : 'boss';
};
